import logoBlack from '@/assets/orbit-logo-full-black.png';
import logoWhite from '@/assets/orbit-logo-full-white.png';
import { useMediaQuery } from '@/hooks/useMediaQuery';

interface AppLoaderProps {
    fading?: boolean;
}

export function AppLoader({ fading = false }: AppLoaderProps) {
    const prefersReducedMotion = useMediaQuery('(prefers-reduced-motion: reduce)');

    return (
        <div
            className={[
                'fixed inset-0 z-[200] flex flex-col items-center justify-center',
                prefersReducedMotion ? 'bg-background' : 'bg-black',
                fading ? 'opacity-0' : 'opacity-100',
                ...(!prefersReducedMotion ? ['transition-opacity duration-700 ease-in-out'] : []),
            ].join(' ')}
            role="status"
            aria-live="polite"
            aria-label="Loading Orbit"
        >
            {prefersReducedMotion ? (
                <>
                    <img
                        src={logoBlack}
                        alt=""
                        aria-hidden="true"
                        className="block w-[32rem] max-w-[80vw] dark:hidden"
                    />
                    <img
                        src={logoWhite}
                        alt=""
                        aria-hidden="true"
                        className="hidden w-[32rem] max-w-[80vw] dark:block"
                    />
                </>
            ) : (
                <video
                    src="/origin-orbit-animated.mp4"
                    autoPlay
                    muted
                    playsInline
                    aria-hidden="true"
                    className="w-[32rem] max-w-[80vw]"
                />
            )}
            <div className="mt-8 h-0.5 w-64 max-w-[70vw] overflow-hidden rounded-full bg-white/10">
                <div className="bg-origin-blue animate-orbit-loader-slide h-full w-2/5 rounded-full motion-reduce:animate-none" />
            </div>
        </div>
    );
}
